export default "__VITE_ASSET__E$QAt$8V__"